var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("@/static/personalCenter/clear.png")

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }